import React from "react";
import Icon from "../../../components/AppIcon";

const FormInput = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  type = "text",
  placeholder = "",
  required = false,
  multiline = false,
  rows = 3,
  className = "",
  ...props
}) => {
  const id = `form-input-${name}`;
  const hasError = Boolean(error);
  
  return (
    <div className={className}>
      <div className="flex justify-between">
        <label 
          htmlFor={id} 
          className="block text-sm font-medium text-gray-700"
        >
          {label} {required && <span className="text-error">*</span>}
        </label>
        
        {hasError && (
          <span className="text-sm text-error flex items-center">
            <Icon name="AlertCircle" size={14} className="mr-1" />
            {error}
          </span>
        )}
      </div>
      
      <div className="mt-1 relative">
        {multiline ? (
          <textarea
            id={id}
            name={name}
            value={value || ""}
            onChange={onChange}
            onBlur={onBlur}
            rows={rows}
            className={`
              block w-full rounded-md shadow-sm 
              focus:ring-primary focus:ring-2 focus:outline-none
              ${hasError 
                ? 'border-error focus:border-error' :'border-gray-300 focus:border-primary-500'
              }
            `}
            placeholder={placeholder}
            aria-invalid={hasError}
            aria-describedby={hasError ? `${id}-error` : undefined}
            {...props}
          />
        ) : (
          <input
            id={id}
            name={name}
            type={type}
            value={value || ""}
            onChange={onChange}
            onBlur={onBlur}
            className={`
              block w-full rounded-md shadow-sm 
              focus:ring-primary focus:ring-2 focus:outline-none
              ${hasError 
                ? 'border-error focus:border-error' :'border-gray-300 focus:border-primary-500'
              }
            `}
            placeholder={placeholder}
            aria-invalid={hasError}
            aria-describedby={hasError ? `${id}-error` : undefined}
            {...props}
          />
        )}
      </div>
      
      {hasError && (
        <p className="mt-2 text-sm text-error" id={`${id}-error`}>
          {error}
        </p>
      )}
    </div>
  );
};

export default FormInput;